import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { Module } from '@library/store/modules/modules.interface';
import { Room } from '@library/store/rooms/rooms.interface';
import { SidebarRoomService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/sidebar-room.service';
import {  debounceTime, distinctUntilChanged, firstValueFrom, tap } from 'rxjs';
import * as moment from 'moment-timezone';
import { SetPointService } from '../set-point.service';
import { MainService } from 'src/app/modules/main/main.service';

@Component({
  selector: 'app-end-time',
  templateUrl: './end-time.component.html',
  styleUrls: ['./end-time.component.scss'],
})
export class EndTimeComponent {
  form = new FormGroup({
    endTime: new FormControl(null, Validators.required)
  });

  minEndTime;
  maxEndTime;

  @Input() module: Module;
  @Input() room: Room;

  constructor(
    public sidebarRoomService: SidebarRoomService,
    private homesFacade: HomesFacade,
    private setPointService: SetPointService,
    private mainService: MainService,
  ) {

  }

  async ngOnInit() {
    const setPointDefaultDuration = (await firstValueFrom(this.homesFacade.currentHome$)).therm_setpoint_default_duration;
    const homeId = await firstValueFrom(this.homesFacade.currentHomeId$);

    // init min and max slider depending on now and add 12hrs
    const now = moment().unix();
    const now_5_min = now + 300 - (now % 300);

    this.minEndTime = now_5_min;
    this.maxEndTime = now_5_min + 3600 * 12;

    // init end time from api if we have or create a default from default duration
    if (this.room.therm_setpoint_mode === 'manual' && this.room.therm_setpoint_end_time) {
      this.form.patchValue({endTime: this.room.therm_setpoint_end_time});
      this.setPointService.endTime = this.room.therm_setpoint_end_time;
    }
    else {
      const end_time = now + setPointDefaultDuration * 60;
      this.form.patchValue({endTime: end_time + 300 - (end_time % 300)});
      this.setPointService.endTime = end_time + 300 - (end_time % 300);
    }

    // call api when slider not touched since 400ms
    this.form.controls.endTime.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      tap((endTime) => {
        this.setPointService.endTime = endTime;
        this.setPointService.changeSetPoint(homeId, this.room.id, 'manual');
      })
    ).subscribe();

  }
  manualBoostEndTime() {
    // therm_setpoint_end_time to readable
    return moment(this.form.get('endTime').value * 1000).format('HH:mm');
  }

  async quitManualBoost() {
    const homeId = await firstValueFrom(this.homesFacade.currentHomeId$);
    await firstValueFrom(this.setPointService.changeSetPoint(
      homeId,
      this.room.id,
      'home',
    ));

    this.mainService.loadHomeStatus();

  }
}
